


import React, { useState, useEffect } from "react";
import config from "../../Common/Configurations/APIConfig";
import apiService from "../../Common/Configurations/APIService";
import Header from "../../Common/Layout/Header";
import { useAuth } from "../../Common/Configurations/AuthContext";
import { useNavigate } from "react-router-dom";
import VisaTabs from "./VisaTabs";

const VisaMasterList = () => {
  const { user, loading: authLoading } = useAuth();
  const navigate = useNavigate();
  const [lists, setLists] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedLetter, setSelectedLetter] = useState("A"); // "A" is default
  const [dataLoading, setDataLoading] = useState(false);

  const alphabets = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

  const GetData = async () => {
    setDataLoading(true);
    try {
      const url = config.GET_ALL_VISAS;
      const res = await apiService.get(url);
      setLists(res || []);
    } catch (error) {
      console.error("Error fetching visas", error);
    } finally {
      setDataLoading(false);
    }
  };

  useEffect(() => {
    if (user) GetData();
  }, [user]);

  if (authLoading) return <p>Loading...</p>;
  if (!user) navigate("/");

  // ✅ IMPROVED FILTER LOGIC
  const filteredLists = lists.filter((v) => {
    if (searchTerm.trim() !== "") {
      // 1. If searching, search GLOBALLY (ignore the alphabet buttons)
      return v.name?.toLowerCase().includes(searchTerm.toLowerCase());
    } else {
      // 2. If NOT searching, filter by the selected letter
      return v.name?.toUpperCase().startsWith(selectedLetter);
    }
  });

  return (
    <div id="layout-wrapper">
      <Header User={user} />
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="card">
              <div className="p-2">
                <VisaTabs pageName="VISAMASTERLIST" />
              </div>
              <div className="card-header">
                <div className="row align-items-center">
                  <div className="col-md-4">
                    <h4 className="card-title mb-0">Visa Master Countries</h4>
                  </div>
                  <div className="col-md-8">
                    <div className="search-box">
                      <input 
                        type="text" 
                        className="form-control" 
                        placeholder="Search any country globally..." 
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                      />
                    </div>
                  </div>
                </div>

                {/* ✅ Alphabet Pagination (All option removed) */}
                <div className="d-flex flex-wrap gap-1 mt-3 justify-content-center">
                  {alphabets.map((char) => (
                    <button
                      key={char}
                      disabled={searchTerm.length > 0} // Disable buttons while searching to avoid confusion
                      className={`btn btn-sm ${selectedLetter === char && searchTerm === "" ? "btn-primary" : "btn-soft-primary"}`}
                      onClick={() => setSelectedLetter(char)}
                      style={{ minWidth: '38px', fontWeight: 'bold' }}
                    >
                      {char}
                    </button>
                  ))}
                </div>
                {searchTerm && (
                  <div className="text-center mt-2">
                    <small className="text-muted">Showing global search results for "{searchTerm}"</small>
                  </div>
                )}
              </div>

              <div className="card-body">
                {dataLoading ? (
                  <div className="text-center py-5">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                    <p className="mt-2 text-muted">Loading visa countries...</p>
                  </div>
                ) : (
                  <div className="table-responsive">
                    <table className="table align-middle table-nowrap">
                      <thead className="table-light">
                        <tr>
                          <th>Flag</th>
                          <th>Country Name</th>
                          <th>Process Type</th>
                          <th>Status</th>
                          <th>Visas Count</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredLists.map((v) => (
                          <tr key={v.visaCountryId}>
                            <td>
                              <span className={`fi fi-${v.flagSrc?.toLowerCase()}`}></span> {v.flagSrc}
                            </td>
                            <td>{v.name}</td>
                            <td><span className="badge bg-info">{v.processingType}</span></td>
                            <td>
                              {v.isActive ? 
                                <span className="badge bg-success">Active</span> : 
                                <span className="badge bg-danger">Inactive</span>
                              }
                            </td>
                            <td>{v.visas?.length || 0} Visas</td>
                            <td>
                              <button 
                                className="btn btn-sm btn-soft-primary"
                                onClick={() => navigate(`/visa-master/details/${v.visaCountryId}`)}
                              >
                                <i className="ri-eye-fill align-bottom me-1"></i> View Details
                              </button>
                            </td>
                          </tr>
                        ))}
                        {filteredLists.length === 0 && !dataLoading && (
                          <tr>
                            <td colSpan="6" className="text-center py-4 text-muted">
                              {searchTerm 
                                ? `No countries found matching "${searchTerm}"` 
                                : `No countries found starting with "${selectedLetter}"`}
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VisaMasterList;